// extracted by mini-css-extract-plugin
module.exports = {"link":"swapLink_link__1ph_b","linkIcon":"swapLink_linkIcon__31W82","linkText":"swapLink_linkText__3MPHn","swapLink":"swapLink_swapLink__3pLDq"};